export enum EAddressType {
    WAVES = 'WAVES',
    ETHEREUM = 'ETHEREUM',
}
